export enum EGlobalSex {
  girl = 0,
  boy = 1,
  other = 2,
}
